import React from "react";
import Typography from "@insite/mobius/Typography";
import { css } from "styled-components";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";

const enum fields {
    backgroundImage = "backgroundImage",
    text = "text"
}

interface Props extends WidgetProps {
    fields: {
        [fields.backgroundImage]: string;
        [fields.text]: string;
    }
}

const DividerEWidget: React.FC<Props> = (props) => {
    const wrapperStyles = {
        css: css`
            text-align: center;
            background-image: url(${props.fields.backgroundImage});
        
        `
    }

    return (
        <StyledWrapper {...wrapperStyles}>
            <Typography>{parse(props.fields.text, parserOptions)}</Typography>
        </StyledWrapper>
    )
}


const widgetModule: WidgetModule = {
    component: DividerEWidget,
    definition: {
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.backgroundImage,
                editorTemplate: "ImagePickerField",
                displayName: "Divider Background image",
                tooltip: "Image Size has to be 330 x 229",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.text,
                editorTemplate: "RichTextField",
                displayName: "Divider Label",
                defaultValue: "",
            },
            ],
            group: "Common",
    }
}

export default widgetModule;